import type { SVGProps, ReactElement } from 'react'

const Cart = (props: SVGProps<SVGSVGElement>): ReactElement => {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            {...props}
        >
            <g clipPath="url(#header-cart-clip)">
                <path
                    d="M31.0194 11.1318C31.2628 11.1396 31.5297 11.1554 31.7103 11.313C31.938 11.51 31.9694 11.8409 31.9851 12.1483C32.0714 14.7171 31.8045 17.3017 31.2 19.7997C31.1136 20.1464 31.0194 20.5089 30.8074 20.8004C30.2814 21.5333 29.253 21.6357 28.3501 21.6672C25.5866 21.7697 21.041 21.8642 18.2854 21.6593C17.5552 21.6042 16.5974 21.6672 16.3933 22.3685C16.252 22.8492 16.5974 23.3693 17.0528 23.582C17.5081 23.7948 18.6151 23.7475 19.1175 23.7554C21.1509 23.8184 27.8791 23.6136 28.9311 23.7633C29.1588 23.7948 29.4728 23.8657 29.6377 24.047C29.8418 24.2676 29.8418 24.6616 29.7083 24.9137C29.4728 25.3708 27.5415 25.3787 27.1725 25.4023C25.516 25.489 22.0852 25.5441 20.4286 25.5914C19.2746 25.6229 18.1126 25.6623 16.9586 25.6545C16.197 25.6466 16.0008 25.5441 15.7888 25.3865C15.4826 25.1501 15.4669 24.6616 15.2392 23.8263C15.043 23.1092 13.198 16.5453 12.6956 14.8511C12.201 13.1727 11.306 11.1554 9.55522 11.0924C9.23334 11.0766 8.8879 11.1396 8.56602 11.0608C8.24413 10.982 7.9301 10.6668 8.01646 10.3438C8.06356 10.1546 8.22843 10.0286 8.3933 9.92613C9.93206 8.9569 10.9998 9.86309 12.2716 10.5802C13.8025 11.4391 13.8967 11.2106 15.7888 11.1318C19.9654 10.9584 26.8428 10.9899 31.0194 11.1318Z"
                    fill="currentColor"
                />
                <path
                    d="M18.7396 30.4625C18.0016 30.6201 17.2793 30.3364 16.8161 29.7612C16.1174 28.8865 16.2273 27.5075 17.1458 26.8141C17.8053 26.3177 18.7945 26.4044 19.4854 26.8062C21.1027 27.7518 20.4903 30.0922 18.7396 30.4625Z"
                    fill="currentColor"
                />
                <path
                    d="M28.1296 30.2402C28.7733 29.9092 29.1188 29.1685 29.1188 28.4672C29.1188 28.1441 29.0481 27.7501 28.8754 27.4664C28.5457 26.9464 27.8784 26.4893 27.2581 26.4421C26.5987 26.3869 25.9863 26.5997 25.5781 27.1276C25.2169 27.6004 25.0756 28.215 25.2012 28.7903C25.4603 30.0274 27.0069 30.8154 28.1296 30.2402Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="header-cart-clip">
                    <rect
                        width="24"
                        height="21"
                        fill="white"
                        transform="translate(8 9.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

export default Cart
